// extracted by mini-css-extract-plugin
module.exports = {"section_container":"CardsContainer_section_container__2gNl0","not_find_recipes":"CardsContainer_not_find_recipes__1yy31"};